import { velynkService } from "./base";

export const userLogin = (params) => {
    return velynkService.post('auction_users/sign_in', params);
};

export const userLogout = (params) => {
    return velynkService.delete('auction_users/sign_out', params);
};